module.exports = __webpack_public_path__ + "static/media/alaska_harinadetrigo.6ab8a5c5.png";